import { 
  FaChalkboardTeacher, 
  FaBuilding, 
  FaHandshake, 
  FaChartLine 
} from "react-icons/fa";
import "./emprendimiento.css";
import RegisterTwo from "../../components/registertwo";

const Emprendimiento = () => {
  return (
    <section className="emprendimiento-section">
      <div className="container text-center emprendimiento-main">
        <h1 className="display-4">EMPRENDIMIENTO</h1>
        <p className="lead">
          Sesiones diseñadas para emprendedores que buscan potenciar sus negocios y alcanzar el éxito.
        </p>

        <div className="row g-4 mb-4">
          {/* Tarjeta 1: Asesoría técnica bilingüe */}
          <div className="col-12 col-md-6 col-lg-3">
            <div className="card emprendimiento-card">
              <div className="card-body text-center">
                <div className="icon-circle">
                  <FaChalkboardTeacher className="icon" />
                </div>
                <h2 className="emprendimiento-card-title">Asesoría Técnica Bilingüe</h2>
                <p className="text-muted">
                  Recibe orientación profesional en dos idiomas para impulsar tu negocio.
                </p>
              </div>
            </div>
          </div>

          {/* Tarjeta 2: Cámaras de comercio locales */}
          <div className="col-12 col-md-6 col-lg-3">
            <div className="card emprendimiento-card">
              <div className="card-body text-center">
                <div className="icon-circle">
                  <FaBuilding className="icon" />
                </div>
                <h2 className="emprendimiento-card-title">Cámaras de Comercio Locales</h2>
                <p className="text-muted">
                  Conéctate con instituciones locales que ofrecen apoyo y capacitación.
                </p>
              </div>
            </div>
          </div>

          {/* Tarjeta 3: Vínculos con organizaciones */}
          <div className="col-12 col-md-6 col-lg-3">
            <div className="card emprendimiento-card">
              <div className="card-body text-center">
                <div className="icon-circle">
                  <FaHandshake className="icon" />
                </div>
                <h2 className="emprendimiento-card-title">Vínculos con Organizaciones</h2>
                <p className="text-muted">
                  Establece alianzas estratégicas con entidades que impulsan la inversión.
                </p>
              </div>
            </div>
          </div>

          {/* Tarjeta 4: Herramientas de marketing */}
          <div className="col-12 col-md-6 col-lg-3">
            <div className="card emprendimiento-card">
              <div className="card-body text-center">
                <div className="icon-circle">
                  <FaChartLine className="icon" />
                </div>
                <h2 className="emprendimiento-card-title">Herramientas de Marketing</h2>
                <p className="text-muted">
                  Potencia tu presencia online y posiciona tu marca con estrategias efectivas.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center mt-4">
          <button className="btn btn-warning">
            DESCUBRE NUEVAS OPORTUNIDADES
          </button>
        </div>
      </div>

      {/* Componente de Registro (full width, se muestra según sus propios estilos) */}
      <RegisterTwo />
    </section>
  );
};

export default Emprendimiento;